<mat-card class="mat-card-tonnage">
  <mat-card-header>
    <mat-card-title>{{ 'tonnage.title' | translate }}</mat-card-title>
    <!-- <mat-card-subtitle>Veuillez saisir tout les champs</mat-card-subtitle> -->
  </mat-card-header>
  <form [formGroup]="tonnageForm" (ngSubmit)="onSubmit()">
    <mat-card-content class="mat-card-content-tonnage">
      <div class="content-row">
        <label class="content-row-label">
          <span class="required-asterisk" *ngIf="isRequiredField('company')">*</span>{{ 'label.company' | translate
          }}</label>
        <app-company-list *ngIf="!data?.billed" [control]="$any(tonnageForm).controls['company']"
          class="content-row-input">
        </app-company-list>
        <label *ngIf="data?.billed">{{data?.company?.name}}</label>
      </div>
      <div class="content-row">
        <label class="content-row-label">
          <span class="required-asterisk" *ngIf="isRequiredField('site')">*</span>{{ 'label.site' | translate }}</label>
        <app-site-list *ngIf="!data?.billed" [control]="$any(tonnageForm).controls['site']" class="content-row-input"
          [pacoOnly]="true">
        </app-site-list>
        <label *ngIf="data?.billed">{{data?.site?.name}}</label>
      </div>
      <div class="content-row">
        <label class="content-row-label">
          <span class="required-asterisk" *ngIf="isRequiredField('type')">*</span>{{ 'label.type' | translate }}</label>
        <mat-radio-group *ngIf="!data?.billed" aria-label="Select an option" formControlName="type"
          class="content-row-input">
          <mat-radio-button value="1">{{ 'label.loading' | translate }}</mat-radio-button>
          <mat-radio-button value="0">{{ 'label.unloading' | translate }}</mat-radio-button>
        </mat-radio-group>
        <label *ngIf="data?.billed">{{(data?.isLoading == true ? 'label.loading' : 'label.unloading') |
          translate}}</label>

      </div>
      <div class="content-row">
        <label class="content-row-label">
          <span class="required-asterisk" *ngIf="isRequiredField('date')">*</span>{{ 'label.date' | translate }}</label>
        <mat-form-field class="content-row-input" *ngIf="!data?.billed">
          <input matInput [matDatepicker]="dateTonnage" formControlName="date" autocomplete="off" [min]="uiService.getMinDate()"
          [max]="uiService.getMaxDate()">
          <mat-datepicker-toggle matSuffix [for]="dateTonnage"></mat-datepicker-toggle>
          <mat-datepicker #dateTonnage></mat-datepicker>
        </mat-form-field>
        <label *ngIf="data?.billed">{{data?.date | date : 'dd/MM/yyyy'}}</label>
      </div>
      <div class="content-row">
        <label class="content-row-label">
          <span class="required-asterisk" *ngIf="isRequiredField('orderReference')">*</span>{{ 'label.order-reference' |
          translate }}</label>
        <mat-form-field class="content-row-input" *ngIf="!data?.billed">
          <input matInput formControlName="orderReference" type="text" autocomplete="off">
        </mat-form-field>
        <label *ngIf="data?.billed">{{data?.orderReference}}</label>
      </div>
      <div class="content-row">
        <label class="content-row-label">
          <span class="required-asterisk" *ngIf="isRequiredField('quantity')">*</span>{{ 'label.quantity' | translate
          }}</label>
        <mat-form-field class="content-row-input" *ngIf="!data?.billed || editMode">
          <input matInput formControlName="quantity" type="number" autocomplete="off">
          <span matSuffix>{{ 'label.tonne(s)' | translate }}</span>
        </mat-form-field>
        <label *ngIf="data?.billed && !editMode">{{data?.quantity | number :'0.2' :'fr'}} {{ 'label.tonne(s)' |
          translate }}</label>
      </div>
      <div class="content-row">
        <label class="content-row-label">
          <span class="required-asterisk" *ngIf="isRequiredField('material')">*</span>{{ 'label.material' | translate
          }}</label>
        <app-material-list *ngIf="!data?.billed || editMode" [control]="$any(tonnageForm).controls['material']"
          class="content-row-input" [displayAddButton]="!data?.billed">
        </app-material-list>
        <label *ngIf="data?.billed && !editMode">{{data?.material?.name }}</label>
      </div>
      <div class="content-row">
        <label for="isExceptionalCheckbox" class="content-row-label">
          <span class="required-asterisk" *ngIf="isRequiredField('isExceptionalConvoy')">*</span>{{
          'label.is-exeptionnal-convoy' | translate
          }}</label>
        <mat-checkbox *ngIf="!data?.billed" id="isExceptionalCheckbox" formControlName="isExceptionalConvoy">
        </mat-checkbox>
        <label *ngIf="data?.billed">{{(data?.isExceptionalConvoy ? 'button.yes' : 'button.no') | translate}}</label>
      </div>
      <div class="content-row">
        <label class="content-row-label">
          <span class="required-asterisk" *ngIf="isRequiredField('ship')">*</span>{{ 'label.ship' | translate }}</label>
        <app-ship-list *ngIf="!data?.billed || editMode" [control]="$any(tonnageForm).controls['ship']" class="content-row-input"
          [displayAddButton]="!data?.billed">
        </app-ship-list>
        <label *ngIf="data?.billed && !editMode">{{data?.shipName }}</label>
      </div>
      <div class="content-row">
        <label class="content-row-label">
          <span class="required-asterisk" *ngIf="isRequiredField('origineSite')">*</span>{{ 'label.from' | translate
          }}</label>
        <app-site-list [control]="$any(tonnageForm).controls['origineSite']" class="content-row-input"
          *ngIf="!data?.billed" [pacoOnly]="false" [displayAddButton]="!data?.billed">
        </app-site-list>
        <label *ngIf="data?.billed">{{data?.origineName }}</label>
      </div>
      <div class="content-row">
        <label class="content-row-label">
          <span class="required-asterisk" *ngIf="isRequiredField('destinationSite')">*</span>{{ 'label.to' | translate
          }}</label>
        <app-site-list [control]="$any(tonnageForm).controls['destinationSite']" class="content-row-input"
          *ngIf="!data?.billed" [pacoOnly]="false" [displayAddButton]="!data?.billed">
        </app-site-list>
        <label *ngIf="data?.billed">{{data?.destinationName }}</label>
      </div>
    </mat-card-content>
    <mat-card-actions class="tonnage-card-action">
      <button mat-raised-button color="warn"
        *ngIf="dialogRef && data?.billed && uiService.visibleByRole([Role.manager, Role.administrator])" type="button"
        (click)="onEdit()">
        <mat-icon>edit</mat-icon> {{ 'button.edit' | translate }}
      </button>
      <button mat-raised-button color="warn" *ngIf="dialogRef && !data?.billed" type="button" (click)="onCancel()">
        <mat-icon>clear</mat-icon> {{ 'button.cancel' | translate }}
      </button>
      <button mat-raised-button color="warn"
        *ngIf="dialogRef && !data?.billed && uiService.visibleByRole([Role.manager, Role.administrator])" type="button"
        (click)="onDelete()">
        <mat-icon>delete</mat-icon> {{ 'button.delete' | translate }}
      </button>
      <button mat-raised-button color="primary" [disabled]="tonnageForm.invalid" *ngIf="!data?.billed">
        <mat-icon>save</mat-icon> {{ 'button.save' | translate }}
      </button>
      <button mat-raised-button color="primary" [disabled]="tonnageForm.invalid" type="button" *ngIf="editMode"
        (click)="patch()">
        <mat-icon>save</mat-icon> {{ 'button.save' | translate }}
      </button>
      <button mat-raised-button color="primary" *ngIf="data?.billed" type="button" (click)="onCancel()">
        <mat-icon>clear</mat-icon> {{ 'button.close' | translate }}
      </button>

    </mat-card-actions>
  </form>
</mat-card>